import { Component, OnInit, Input, Optional, Host, SkipSelf, HostBinding, ElementRef, Renderer2, OnDestroy, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import { Subscription } from 'rxjs/Subscription';
import { VocabularyService } from "../services/VocabularyService";
import { LookupModel } from '../../common/models/LookupModel';
import { MatFormFieldControl } from '@angular/material';
import { NgControl, ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, ControlContainer, Validator } from "@angular/forms";
import { Subject } from 'rxjs/Subject'
import { FocusMonitor } from '@angular/cdk/a11y';

@Component({
  selector: 'brd-related-code-system-input',
  templateUrl: './related-code-system-input.component.html',
  styleUrls: ['./related-code-system-input.component.scss'],
  inputs: ['key'],
  providers: [
    { provide: MatFormFieldControl, useExisting: RelatedCodeSystemInputComponent }
  ]
})
export class RelatedCodeSystemInputComponent implements OnInit, OnDestroy, MatFormFieldControl<LookupModel>, ControlValueAccessor {

  shouldPlaceholderFloat?: boolean;

  stateChanges = new Subject<void>();
  destroyed$ = new Subject<boolean>();
  focused: boolean;
  loadedValues: boolean;
  disabled: boolean;
  controlType?: string;
  options: LookupModel[];
  filteredOptions: LookupModel[] = [];
  options$: Observable<LookupModel[]>;
  optionsSubject = new Subject<LookupModel[]>();
  static nextId = 0;
  public lookupControl: AbstractControl;
  propagateChange: any = () => { };
  touched: any = () => { };

  @Input()
  key: string;

  @Input()
  termType: string;

  @Input()
  showCode: boolean;

  @Input()
  formControlName: string;

  @Input()
  placeholder: string;

  @Input()
  required: boolean;

  @Input('options')
  set passedInOptions(options: LookupModel[]) {
    this.options = options;
    this.updateOptions(this.ngControl ? this.ngControl.value : '');
  };

  @Input()
  get value(): any | null {
    return this.empty ? null : this.elementRef.nativeElement.value;
  }
  set value(lookupModel: any | null) {
    this.writeValue(lookupModel);
    this.stateChanges.next();
  }

  @Output()
  selected = new EventEmitter<LookupModel>();

  get errorState() {
    return this.ngControl ? this.ngControl.invalid : false;
  }

  get empty() {
    return this.ngControl == null || this.ngControl.value == null || this.ngControl.value == undefined || this.ngControl.value === "" || this.ngControl.value.length === 0;
  }
  @HostBinding() id = `brd-relationship-type-input-${RelatedCodeSystemInputComponent.nextId++}`;
  @HostBinding('class.floating') get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  constructor(private vocabularyService: VocabularyService,
    @Optional() @Host() @SkipSelf()
    private controlContainer: ControlContainer,
    @Optional() public ngControl: NgControl,
    private focusMonitor: FocusMonitor,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef) {
    focusMonitor.monitor(elementRef.nativeElement, true).takeUntil(this.destroyed$).subscribe(origin => {
      this.focused = !!origin;
      if (this.focused && this.ngControl && !this.ngControl.touched) {
        this.touched();
        this.updateOptions(this.ngControl.value);
      }
      this.stateChanges.next();
    });
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  validLookup(control: AbstractControl) {
    if (control.value == null || control.value.key === null || control.value.key === undefined || control.value.key === "") {
      return { 'validLookup': { value: control.value } };
    }
    return null;
  }

  ngOnInit() {
    if (this.controlContainer) {
      if (this.formControlName) {
        this.lookupControl = this.controlContainer.control.get(this.formControlName);
        this.lookupControl.enable();
        this.lookupControl.setValidators([this.validLookup]);
        this.lookupControl.updateValueAndValidity();
      } else {
        console.warn('Missing FormControlName directive from host element of the component');
      }
    } else {
      console.warn('Can\'t find parent FormGroup directive');
    }

    this.options$ = this.optionsSubject.asObservable();
    if (this.ngControl) {
      this.ngControl
        .valueChanges
        .takeUntil(this.destroyed$)
        .subscribe(value => {
          this.getPage(value);
        });
    }
    this.lookupControl
      .valueChanges
      .takeUntil(this.destroyed$)
      .subscribe((value: LookupModel) => this.selected.emit(value));

    if (this.key && this.lookupControl.enabled) {
      this.getPage('');
    }
  }

  private getPage(term: string) {
    if (this.key) {
      this.vocabularyService.getCodeSystemsVersionsForRelationships(this.key,term)
        .take(1)
        .subscribe(lookups => {
          this.options = lookups;
          this.updateOptions(this.ngControl ? this.ngControl.value : '');
        });
    }
  }

  private updateOptions(value: string): void {
    if (this.options) {
      var valid = this.ngControl ? this.ngControl.value : true;
      this.filteredOptions = this.options.filter(l => valid || !value || Object.prototype.toString.call(value) !== "[object String]" || this.displayFn(l).toLowerCase().includes(value.toLowerCase()));
      this.optionsSubject.next(this.filteredOptions);
    }
    this.changeDetectorRef.markForCheck();
  }


  displayFn(lookupModel?: LookupModel): string | undefined {
    if (lookupModel && lookupModel.key) {
      return lookupModel.description;
    }
    return undefined;
  }

  onEnter() {
    if (this.filteredOptions.length > 0) {
      this.lookupControl.patchValue(this.filteredOptions[0]);
    }
  }

  ngOnDestroy() {
    this.lookupControl.clearValidators();
    this.lookupControl.patchValue('');
    this.lookupControl.updateValueAndValidity();
    this.destroyed$.next(true);
  }

  writeValue(obj: any): void {
    this.renderer.setProperty(this.elementRef.nativeElement, 'value', obj);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.touched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  setDescribedByIds(ids: string[]): void {
  }

  onContainerClick(event: MouseEvent): void {
  }


}



// WEBPACK FOOTER //
// ./src/app/vocabulary/components/related-code-system-input.component.ts